// === IMPORT STYLE CSS / SCSS ===
import '@csstools/normalize.css';
import '../scss/main.scss';

// === IMPORT JS ===
import { initLenis } from './utils/ScrollLenis';
import NavHeight from './utils/nav-height';
import Nav from './layouts/nav';
import NavResponsive from './layouts/nav-responsive';
import VideoPlayers from './libs/videoPlayers';
import SwiperSliders from './libs/swiper';
import NumbersAnimations from './layouts/numbers-animations';
import SwitchTabs from './layouts/switch-tabs';
import Accordions from './layouts/accordions';
import Marquee from './layouts/marquee';
import Forms from './layouts/forms';
import Ajax from './layouts/ajax';
import NiceSelectInit from "./libs/select";
import Hero1Tooltips from "./layouts/Hero1Tooltips";
import MemberDropdown from './layouts/member-dropdown';

const initScripts = () => {
    try {
        const nav = new Nav();
        initLenis((e) => nav.onScroll(e));
        new NavHeight();
        new NavResponsive();
        new SwiperSliders();
        new VideoPlayers();
        new NumbersAnimations();
        new SwitchTabs();
        new Accordions();
        new Marquee();
        new Forms();
        new Ajax();
        new NiceSelectInit();
        new MemberDropdown();
        Hero1Tooltips();

    } catch (error) {
        console.error("Erreur lors de l'initialisation des scripts :", error);
    }
}

if (!document.body.classList.contains('wp-admin')) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
        initScripts();
    } else {
        document.addEventListener("DOMContentLoaded", initScripts);
    }
}